//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalProposedSqFtWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Proposed Sq.Ft' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default TotalProposedSqFtWidget;
